import _find from 'lodash/find';
import {
  SET_TABS,
  SET_ACTIVE_TAB,
  SET_LOADED_TAB,
  SET_SORTS,
  SET_LOAD_MORE,
  SET_SEARCH_TYPE,
  SET_SEARCH_TERM,
  SET_POPSTATE,
  SET_FILTERS,
  APPLY_FILTER,
  APPLY_SORT,
  CLEAR_FILTERS,
  SET_FIRST_QUERY,
} from '@/context/search/types';

export default (state, action) => {
  switch (action.type) {
    case SET_FIRST_QUERY: {
      return {
        ...state,
        query: action.payload,
      };
    }
    case SET_TABS: {
      const activeTab = _find(action.payload, { isActive: true });
      return { ...state, tabs: action.payload, activeTab };
    }
    case SET_ACTIVE_TAB: {
      const updatedTabs = state.tabs.map(tab => {
        tab.isActive = tab.type === action.payload;
        tab.isLoaded = false;
        return tab;
      });
      const activeTab = _find(state.tabs, { isActive: true });
      return {
        ...state,
        tabs: updatedTabs,
        activeTab,
        query: {},
        searchType: action.payload,
        isFirstLoad: false,
        updateHistory: true,
        appliedFilter: false,
      };
    }
    case SET_LOADED_TAB: {
      const updatedTabs = state.tabs.map(tab => {
        if (tab.type === action.payload) tab.isLoaded = true;
        return tab;
      });
      return { ...state, tabs: updatedTabs };
    }
    case SET_SORTS:
      return { ...state, sorts: action.payload };
    case SET_LOAD_MORE:
      return { ...state, hasLoadMore: action.payload };
    case SET_SEARCH_TYPE:
      return { ...state, searchType: action.payload };
    case SET_SEARCH_TERM:
      return { ...state, searchTerm: action.payload };
    case SET_POPSTATE:
      return { ...state, ...action.payload, updateHistory: false };
    case SET_FILTERS:
      return { ...state, filters: action.payload };
    case APPLY_FILTER:
      return {
        ...state,
        query: {
          ...state.query,
          value: action.payload.query.value,
          url: `${DLG.config.encodedContextPath}${action.payload.url}&text=${state.searchTerm}&searchType=${state.searchType}&hasLoadMore=${state.hasLoadMore}`,
        },
        isFirstLoad: false,
        updateHistory: true,
        appliedFilter: true,
      };
    case APPLY_SORT: {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('sort', action.payload);
      return {
        ...state,
        query: {
          ...state.query,
          sort: action.payload,
          url: `${
            DLG.config.encodedContextPath
          }/search?${urlParams.toString()}`,
        },
        isFirstLoad: false,
        updateHistory: true,
        appliedFilter: true,
      };
    }
    case CLEAR_FILTERS: {
      return {
        ...state,
        query: {
          value: state.searchTerm,
          url: `${window.location.pathname}?text=${state.searchTerm}&searchType=${state.searchType}&hasLoadMore=${state.hasLoadMore}`,
        },
        isFirstLoad: false,
        updateHistory: true,
        appliedFilter: true,
      };
    }
    default:
      return { ...state };
  }
};
